export enum EDocumentIcon {
    PDF = 'picture_as_pdf',
    SLIDESHOW = 'slideshow',
    DESCRIPTION = 'description',
    IMAGE = 'image',
    TABLE_CHART = 'table_chart',
    DEFAULT = 'insert_drive_file',
}

export enum EFileType {
    PDF = 'pdf',
    PPT = 'ppt',
    PPTX = 'pptx',
    DOC = 'doc',
    DOCX = 'docx',
    JPG = 'jpg',
    JPEG = 'jpeg',
    PNG = 'png',
}
